import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, Input, Button } from '@chakra-ui/react';
import { TrainGroupsType } from '../Table/MaintenanceTrainGroupsTable';
import { QueryTrainGroupsApi } from '../../../../apis/QueryMaintenance.api';
import { TrainGroupsSearchCondition } from '../../../../pages/TrainGroupsMaintenance';

interface props {
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<TrainGroupsType[] | undefined | null>
  >;
  Query: TrainGroupsSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<TrainGroupsSearchCondition>>;
  createOrUpdate: boolean;
  SearchStateSwitch: () => void;
}

const TrainGroupsSearchBox: React.FC<props> = (props) => {
  const {
    setMaintenanceDatas,
    Query,
    setQuery,
    createOrUpdate,
    SearchStateSwitch
  } = props;

  const [model, setModel] = useState('');
  const [dateCreatedFrom, setDateCreatedFrom] = useState('');
  const [dateCreatedTo, setDateCreatedTo] = useState('');
  const [dateUpdatedFrom, setDateUpdatedFrom] = useState('');
  const [dateUpdatedTo, setDateUpdatedTo] = useState('');

  useEffect(() => {
    setModel('');
    setDateCreatedFrom('');
    setDateCreatedTo('');
    setDateUpdatedFrom('');
    setDateUpdatedTo('');
  }, [createOrUpdate]);

  const SerachGetApi = async () => {
    const params = new URLSearchParams();
    Query.sort.key !== '' &&
      params.append(
        'order',
        Query.sort.key + (Query.sort.sortType ? '_asc' : '_desc')
      );
    model !== '' && params.append('name_contains', model);
    dateCreatedFrom !== '' && params.append('created_at_gte', dateCreatedFrom);
    dateCreatedTo !== '' && params.append('created_at_lt', dateCreatedTo);
    dateUpdatedFrom !== '' && params.append('updated_at_gte', dateUpdatedFrom);
    dateUpdatedTo !== '' && params.append('updated_at_lt', dateUpdatedTo);
    const apiQuery = '/?' + params.toString();

    setQuery((pre) => ({
      ...pre,
      model: model,
      dateCreatedFrom: dateCreatedFrom,
      dateCreatedTo: dateCreatedTo,
      dateUpdatedFrom: dateUpdatedFrom,
      dateUpdatedTo: dateUpdatedTo
    }));

    const response = await QueryTrainGroupsApi(apiQuery);
    if (response.success) {
      setMaintenanceDatas(response.data as TrainGroupsType[]);
      SearchStateSwitch();
    }
  };

  return (
    <>
      <Box
        border='1px'
        borderColor='gray'
        ml={14}
        gridRow='2/3'
        gridColumn='2/2'
        w='80%'
        h='260px'
        bgColor='#f4f4f4'
        fontSize={14}
      >
        <Box fontSize={18} bgColor='#e5e6e7'>
          <Text>検索条件</Text>
        </Box>
        <Box w='90%'>
          <Text ml={2} mt={1}>
            形式
          </Text>
          <Input
            h='8'
            ml={2}
            bgColor='white'
            value={model}
            onChange={(e) => setModel(e.target.value)}
          ></Input>
          <Text ml={2} mt={1}>
            登録日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedFrom}
              onChange={(e) => setDateCreatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedTo}
              onChange={(e) => setDateCreatedTo(e.target.value)}
            />
          </HStack>
          <Text ml={2} mt={1}>
            更新日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedFrom}
              onChange={(e) => setDateUpdatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedTo}
              onChange={(e) => setDateUpdatedTo(e.target.value)}
            />
          </HStack>
          <Button
            ml={2}
            mt={2}
            bgColor='gray.800'
            color='white'
            onClick={() => SerachGetApi()}
          >
            絞り込む
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default React.memo(TrainGroupsSearchBox);
